import React, { useState } from 'react';
import { FormSection, FormRow } from '@tanium/react-form';
import { FormTextInput } from '@tanium/react-form-text-input';
import { FormTextareaInput } from '@tanium/react-form-textarea-input';
import get from 'lodash.get';
import { Field, FieldProps, FormikErrors, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from '@tanium/react-box';
import { useTheme } from '@tanium/react-theme-context';
import { CreateRequestForm } from '../../CreateRequestPage';

export const DETAILS = 'details';
export const TICKET_INFO = 'ticketInfo';

export const RequestDetails = (): React.ReactElement => {
  const { t } = useTranslation();
  const formInputIdPrefix = 'create-request-';
  const [details, setDetails] = useState('');
  const [ticketInfo, setTicketInfo] = useState('');
  const { values } = useFormikContext<CreateRequestForm>();
  const theme = useTheme();

  return (
    <FormSection title={t('DETAILS')}>
      <Field name={TICKET_INFO}>
        {({ form, field }: FieldProps): React.ReactElement => (
          <FormRow
            label={t('TICKET_INFO')}
            description={t('TICKET_INFO_DESCRIPTION')}
            required={values.autoApprove === false}
            errors={(get(form.touched, field.name) && get(form.errors, field.name)) as FormikErrors<string>}
            labelId={`${formInputIdPrefix}${field.name}`}
          >
            <FormTextInput
              className="create-request-details"
              data-testid="ticketInfo"
              {...field}
              placeholder={t('TICKET_INFO_PLACEHOLDER')}
              value={ticketInfo}
              onInput={(event) => {
                const { value } = event.target as any;
                setTicketInfo(value);
                void form.setFieldValue(TICKET_INFO, value);
              }}
              id={`${formInputIdPrefix}${field.name}`}
            />
          </FormRow>
        )}
      </Field>
      <Field name={DETAILS}>
        {({ form, field }: FieldProps): React.ReactElement => (
          <FormRow
            label={t('JUSTIFICATION')}
            required
            description={
              <Box>
                <Box>{t('JUSTIFICATION_DESCRIPTION')}</Box>
                <Box color={theme.colors.warning}>{t('JUSTIFICATION_WARNING')}</Box>
              </Box>
            }
            errors={(get(form.touched, field.name) && get(form.errors, field.name)) as FormikErrors<string>}
            labelId={`${formInputIdPrefix}${field.name}`}
          >
            <FormTextareaInput
              className="create-request-details"
              data-testid="justification"
              {...field}
              placeholder={t('JUSTIFICATION_PLACEHOLDER')}
              value={details}
              onInput={(event) => {
                const { value } = event.target as any;
                setDetails(value);
                void form.setFieldValue(DETAILS, value);
              }}
              id={`${formInputIdPrefix}${field.name}`}
            />
          </FormRow>
        )}
      </Field>
    </FormSection>
  );
};

export default RequestDetails;
